module.exports = __webpack_public_path__ + "img/operation.0c305f23.png";